import styled from 'styled-components';

export const Wrapper = styled.div`
  position:fixed;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #000000;
  color: #fff;
  top: 50px;
  right: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  cursor: url("https://www.somoswaka.com/wp-content/uploads/2017/10/WAKA-cursor-hover.png") 25 30, auto;
`;


export const Image = styled.img`
  cursor: url("https://www.somoswaka.com/wp-content/uploads/2017/10/WAKA-cursor-hover.png") 25 30, auto;
  width: 25px;
  height: 25px;
  color: #ffffff;
`;
